






































































































    import { Component, Vue, Prop } from 'vue-property-decorator';
    import axios from 'axios';
    import { General } from '@/services/General';
    import { ClaimEnum } from '@/services/ClaimEnum';
    import { saveAs } from 'file-saver';
    import { MaterialPrintElementBase } from '@/entity/MaterialBase';
    import { IMaterialDto } from '@/interfaces/IMaterialDto';
    import MaterialDetail from './MaterialDetail.vue';

    @Component({
        components: {
            MaterialDetail
        }
    })
    export default class MaterialsListPrintTool extends Vue {

        @Prop({
            type: Array,
            required: true
        })
        materialList: any[];
        materialTemp: MaterialPrintElementBase[] = [];
        isSaveClicked: boolean = false;

        materialToProcess = {} as IMaterialDto;
        materialDetailModalTitle: string = '';
        processMaterialButton: string = '';
        editModeMaterialDetail: boolean = false;

        @Prop({
            type: Boolean,
            required: false
        })
        showProductsInfo: boolean;

        @Prop({
            required: false
        })
        product: any;

        @Prop({
            type: Boolean,
            required: false,
            default: true
        })
        editProductMode: boolean;

        @Prop({
            type: Boolean,
            required: false,
            default: false
        })
        fromProductDetail: boolean;

        @Prop({
            type: Boolean,
            required:false,
            default:true
        })
        isValidProductCode: boolean;
  
        general: any = {};        
        selectedPackageFormat: any = null;
        loading: boolean = false;
        optionsPackageFormats: any = new Array();
        defaultPackageFormat = {  };
        templateNormal: boolean = false;
        materialSelected: any ={
            IdMaterial:null,
            Description:null,
            SerialNumber:null,
            BatchNumber:null,
            MaterialCode:null,
            PageNumber:1
        }

        resetMaterialSelected(){
            this.materialSelected.IdMaterial = null;
            this.materialSelected.Description = null;
            this.materialSelected.BatchNumber = null;
            this.materialSelected.SerialNumber = null;
            this.materialSelected.MaterialCode = null;
            this.materialSelected.PageNumber = 1;
        }

        async mounted() {
            this.general = General;
            this.defaultPackageFormat = {value: null, text: this.$t('PRODUCT.SELECTION_PACKAGE') as string}
            await this.getPackageFormats();
            this.materialTemp = this.materialList;
        }

        async deleteMaterial(material: MaterialPrintElementBase) {
            if(material.idMaterial === undefined || material.idMaterial === ''){
                let app = this;
                let callSaving = async () =>  {
                    await app.deleteMaterialFromListDo(material);
                }
                General.confirm(this.$t('PRODUCT.DELETE_MATERIAL') as string, app, callSaving);
            } else {
                let app = this;
                let callSaving = async () =>  {
                    await app.deleteMaterialDo(material);
                }
                General.confirm(this.$t('PRODUCT.DELETE_MATERIAL') as string, app, callSaving);
            }
        }
        
        async deleteMaterialDo(material: MaterialPrintElementBase) {
            this.loading = true;
            try {
                let response = await axios({
                    method: "delete",
                    url: General.GetApiUrl("/api/Material/DeleteMaterial?idMaterial=" + material.idMaterial),
                    withCredentials: true
                });
                this.$emit('afterMaterialDetailEditProduct');
                this.closeMaterialDetailModal();
                General.showAlertSuccess(this.$t('PRODUCT.MATERIAL_DELETED') as string, this);
            } catch(error) {
                General.HandleError(error, this, true);
            } finally {
                this.loading = false;
            }
        }

        async deleteMaterialFromListDo(material: MaterialPrintElementBase) {
            if(material.idMaterial || material.idMaterial == "") {
                this.materialTemp = this.materialTemp.filter((m) => {return m.materialCode != material.materialCode});
            }
            this.$emit('afterMaterialDetailAddProduct', this.materialTemp);
        }

		openMaterialDetail(material: any) {        
            if(this.isValidProductCode) {
                if(material) {
                    this.materialToProcess = {} as IMaterialDto;
                    this.materialToProcess.idMaterial = material.idMaterial;
                    this.materialToProcess.materialCode = material.materialCode;
                    this.materialToProcess.originalDescription = material.originalDescription;
                    this.materialDetailModalTitle = this.$t('PRODUCT.EDIT_MATERIAL') as string;
                    this.processMaterialButton = this.$t('PRODUCT.SAVE_MATERIAL') as string;
                    this.editModeMaterialDetail = true;
                } else {
                    this.editModeMaterialDetail = false;
                    this.materialToProcess = {} as IMaterialDto;
                    this.materialDetailModalTitle = this.processMaterialButton = this.$t('PRODUCT.ADD_MATERIAL') as string;
                }
                this.$bvModal.show('material-detail-modal');
            } else {
                General.showAlertDanger(this.$t('PRODUCT.INSERT_PRODUCT') as string, this);
            }
        }

        closeMaterialDetailModal() {
            this.$bvModal.hide('material-detail-modal');
        }

        afterMaterialDetail(material: MaterialPrintElementBase, materialCodeTemp: string) {
            if(!this.editProductMode) {
                if(this.editModeMaterialDetail) {
                    let index = this.materialTemp.findIndex((m) => m.materialCode === materialCodeTemp);
                    this.materialTemp[index] = material;
                    Vue.set(this.materialTemp[index], 'material', material);                
                } else {
                    this.materialTemp.push(material);
                    Vue.set(this.materialTemp[this.materialTemp.length - 1], 'material', material);
                }
                this.$emit('afterMaterialDetailAddProduct', this.materialTemp);
            } else {
                this.$emit('afterMaterialDetailEditProduct');
                this.closeMaterialDetailModal();
            }
                this.closeMaterialDetailModal();
                this.editModeMaterialDetail = false;
                this.materialToProcess = {} as IMaterialDto;
        }
        
        openMaterialDo(material:any){           
            this.materialSelected.IdMaterial = material.idMaterial;
            this.materialSelected.Description = material.description;
            this.materialSelected.MaterialCode = material.materialCode;
            this.$bvModal.show('detail-labelMaterialRequest');
        }

        async openMaterial(materialSelected: any) { 
            if(!this.materialSelected.PageNumber)
                General.showAlertDanger("Please define page number",this);
            else{  
            
            this.loading = true;            
            try {
                let response = await axios({
                    method: 'post',
                    url: General.GetApiUrl("/api/PackageLabel/DownloadPackageLabel"),                    
                    data:{
                       IdMaterial:materialSelected.IdMaterial,
                       SerialNumber:materialSelected.SerialNumber,
                       BatchNumber:materialSelected.BatchNumber,
                       PageNumber:materialSelected.PageNumber
                    },
                    withCredentials: true,
                    responseType: 'blob'
                });           
                
                saveAs(new Blob([response.data]), materialSelected.MaterialCode + ".pdf");
            } catch (error) {
                General.showAlertDanger("Download error, please retry. If the problem stll present contact your IT", this);                
                
            } finally {
                this.loading = false;
            }
            }
            
        }
        
        /*
            Metodo di verifica autorizzazione al processamento manuale dei prodotti/manuali, basato su 3 condizioni:
            1: Utente facente parte di una country (Country Father) non gestita da SAP
            2: Il componente viene renderizzato dai dettagli prodotto (O aggiunta prodotto), quindi non dalla pagina di ricerca materiali
            3: il prodotto non e' stato importato da SAP
        */
        canUserManualProcessProduct() {
            return General.CanManualProcessProduct() && this.fromProductDetail && (this.product != null ? !this.product.importedFromSAP : true);
        }
    
        async getPackageFormats() {
            
            let apiUrl = General.GetApiUrl('/api/packagelabel/GetPackageLabelFormats');
            try {
                let response = await axios({
                    method: 'get',
                    url: apiUrl,
                    responseType: 'json',
                    withCredentials: true
                });

                this.optionsPackageFormats = this.convertPackageToSelect(response.data, true);
            } catch (error) {
                General.HandleError(error, this);
            }
            
        }

        convertPackageToSelect(data: any, addEmpty: boolean) {
            let outputData = new Array();
            if (addEmpty)
                outputData.push(this.defaultPackageFormat);
            data.forEach(function (item: any) {
                outputData.push({
                    value: item.id,
                    text: item.name
                });
            });
            return outputData;
        };
        get userCanPrint() {
            return General.CheckAuthorization(ClaimEnum.CanPrintPackageLabel);
        }
        materialCanBePrinted(material) {
            
            if (material.packageSize != undefined && material.packageSize != null) {
                return material.packageSize.item4;
            }
            return false;
        }
        /*
        getPackageLabelUrl(material:any):string {
            
            
            let url = General.getPackageLabelUrl(material.idMaterial, this.selectedPackageFormat, '0', '0', '0', '100', '0', this.templateNormal);
                
           
            return url;
        }
        */
    }
